import { render, staticRenderFns } from "./newData.vue?vue&type=template&id=64e0cf56&scoped=true&"
import script from "./newData.vue?vue&type=script&lang=js&"
export * from "./newData.vue?vue&type=script&lang=js&"
import style0 from "./newData.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./newData.vue?vue&type=style&index=1&id=64e0cf56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e0cf56",
  null
  
)

export default component.exports